import { HtmlBlock } from '@/cms/definitions/content-types';
import BuyInsuranceSettings from '../BuyInsuranceSettings';
import { exception } from '@/appinsights/logging/ApplicationInsightLog';

export class HomeSettings extends BuyInsuranceSettings {
	public sumsLabel: string;
	public sumsSelectDefault: string;
	public ownHomeCheck = false;
	public ownHomeCalculationTitle = '';
	public ownHomeCalculationContent = '';
	public ownHomeUrl = '';

	public constructor(settingsBlock: HtmlBlock) {
		super(settingsBlock);
		this.loadHomeSettings();
	}

	/**
	 * load settings from CMS if present
	 */
	private loadHomeSettings() {
		try {
			let setting: string;
			const settingsArr = this.settingsBlock.markup.split('$');
			settingsArr.forEach((setting_) => {
				setting = setting_.toLowerCase().trim();
				if (setting.startsWith('sumslabel=')) {
					this.sumsLabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('sumsselectdefault=')) {
					this.sumsSelectDefault = this.getSettingsValue(setting_);
				} else if (setting.startsWith('ownhomecheck=')) {
					this.ownHomeCheck = JSON.parse(this.getSettingsValue(setting_));
				} else if (setting.startsWith('ownhomecalculationtitle=')) {
					this.ownHomeCalculationTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('ownhomecalculationcontent=')) {
					this.ownHomeCalculationContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('ownhomeurl=')) {
					this.ownHomeUrl = this.getSettingsValue(setting_);
				}
			});
		} catch (e) {
			exception(e);
		}
	}
}
